import React from 'react';
import { Empty } from 'antd';
import CNEDailyStatsPage from '../../pages/CNEDailyStatsPage';
import WindowNote from './WindowNote';

/**
 * CNE agent stats for the campaign, rendered by the page that already computes them.
 *
 * Offered only where the campaign actually has daily rows, which the campaigns
 * endpoint answers from the data rather than from a flag somebody has to
 * remember to set. Upload a campaign's first daily file and the tab appears.
 */
export default function CNEStatsTab({ campaignId, from, to }) {
  if (!campaignId) {
    return <Empty description="Select a campaign" image={Empty.PRESENTED_IMAGE_SIMPLE} style={{ marginTop: 40 }} />;
  }
  return (
    <>
      <WindowNote from={from} to={to} />
      <CNEDailyStatsPage embedded campaignId={campaignId} from={from} to={to} />
    </>
  );
}
